export const eventBusTypes = {
  EventBus: Symbol.for('EventBus'),
}
